import React, { Component } from 'react';
import { defaultAppTitle } from '../config/functions'
import { Helmet } from 'react-helmet';
import { BadgesPlayground, ContentBlock, Hero, ProjectBrands, Signpost, Skillset } from '../components';
import { LazyImage } from '../components/Global';
import { Link } from 'react-router-dom';

class About extends Component {
    constructor(props) {
        super(props);

        this.state = {
            metaDescription: 'I am a freelance front and backend web developer based in Leeds, West Yorkshire. I have over 10 years industry experience both as a full time employee and as a freelancer. I\'ve worked with different sizes companies in Leeds and in Sydney, Australia (where I spent a year living and working). I love travelling, skydiving and cats.'
         };
    }

    render() {
        return (
            <div key="About">
                <Helmet>
                    <title>{`About me // ${defaultAppTitle}`}</title>
                    <meta name="description" content={this.state.metaDescription} />
                    <meta name="og:description" content={this.state.metaDescription} />
                </Helmet>
                <Hero ref="heroContainer" showHint={true}>
                    <h1 className="alpha">About</h1>
                    <h2 className="beta">
                        {"I have more than 10 years experience working with websites of all shapes and sizes. I’ve worked with business across the globe having spent time living and working abroad - ranging from small, ambitious startups, digital agencies right through to large corporate organisations."}
                    </h2>

                    <BadgesPlayground />
                </Hero>

                <ContentBlock className="content-block content-block--contained">
                    <h3 className="beta u-text-center u-no-bm">{"I can create a website that'll look great on every device and maximise your brand's potential. Let me worry about what's going on under the hood, but I have huge experience with all kinds of web technology."}</h3>
                </ContentBlock>

                <ContentBlock className="content-block">
                    <Skillset />
                </ContentBlock>

                <ContentBlock className="content-block">
                    
                    <Signpost className="c-signpost c-signpost--single u-text-left" isActive={true}>
                        <div className="c-signpost__columns">
                            <div className="c-signpost__column c-signpost__image">
                                <LazyImage src={'//cdn.buttercms.com/f3MGwGaDTneTYgt7v55Z'} width={640} height={420} alt={'Dave Walker working with a designer'} />
                            </div>
                            <div className="c-signpost__column">
                                <div className="c-signpost__overlay-content u-padding">
                                    <p className="c-signpost__text">{"I can work with any businesses size - small to large, and with existing teams of designers and developers."}</p>
                                    <Link className="c-signpost__link u-more-link u-unstyled" to="/hello">Get in touch</Link>
                                </div>
                            </div>
                        </div>
                    </Signpost>
                </ContentBlock>

                <ContentBlock className="content-block content-block--fluid content-block--primary">
                    <ContentBlock className="content-block u-no-padding">
                        <ProjectBrands />
                    </ContentBlock>
                </ContentBlock>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js